
import NotificationsButton from "./NotificationsButton";
import ProfileCircleButton from "./ProfileCircleButton";
import AllRecipe from "./AllRecipe";
import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { settings } from "../config";
import { MostPopularCardDashRoute } from "../routes";
import Loading from "./Loading";
import MostPopularCard from "./MostPopularCard";
import BackButton from "./BackButton";
import VideoCard from "./VideoTiles";
import { useSelector } from "react-redux";
import LogoSideButton from "./LogoSideButton";


const MostPopularNew = () => {
const language = useSelector((state) => state.language);
const [allrecipe,setallrecipe] = useState([]);
const [recipe, setrecipe] = useState([]);
const [flag, setflag] = useState(false);
const history = useHistory();
const id=1;
const type=language.lang["most-popular"];
const [offset, setoffset] = useState(0);
const [limit, setlimit] = useState(10);
const [pageLoading, setpageLoading] = useState(false);
useEffect(() => {
    !flag && FetchRecipes(offset);
  },[])
  const FetchRecipes = async (off) =>{
    //categoryIds=${3}&categoryIds=${1}&categoryIds=${6}&categoryIds=${12}&
    await axios.get(`${settings.apiBaseURL}/getSingleFeatureByMostPopular?offset=${off}&limit=${limit}`)
            .then((response) => {
              setallrecipe((prevState) => [...prevState, ...response.data.response]);
          })
          .catch((error) => { console.log(error.response.status) })
          .finally(()=>{setflag(true); setpageLoading(false); })
  }
  const routeRecipe = (recipe) =>{
    history.push(MostPopularCardDashRoute.path, {
      list: recipe,
      listid: id,
      pagetitle: type
    });
  }
  const handleScroll = (event) => {
    setpageLoading(true);
    console.log("scrolling most popular --");
    const target = event.target;
    if (target.scrollWidth - target.scrollLeft === target.clientWidth) {
      console.log("get most popular ");
      FetchRecipes(offset + limit);
      setoffset(offset + limit);
      if(limit === 10) setlimit(5);
    }
  };

  return (
    <section className="row px-4">
    <div className="d-flex justify-content-between p-0 m-0 align-items-center">
      <div className="d-flex align-items-center">
      <div><LogoSideButton /></div>
      <div><BackButton /></div>
        <div>
            <h3 className="Page-title-custom">{language.lang["most-popular"]}</h3>
            <div className="title-border"></div>
        </div>
        </div>
        <div className="d-flex">
          <NotificationsButton className="ml-auto" />
          <ProfileCircleButton />
        </div>
      </div>
    <div className="d-flex justify-content-center w-100">
        <section className="row pt-4 px-4 w-100">

          <div className="grid-layout justify-content-center" style={{gap:'20px'}} onScroll={handleScroll}> 
          {flag && allrecipe ?
                allrecipe.length > 0 ? allrecipe.filter((a)=>{ return(recipe.id !=a.id)}).map((item, i) => {
                    return (
                    <div
                        className="d-flex justify-content-around scroll-snap-start"
                        style={{ maxHeight: "200px",cursor: "pointer", 'margin-bottom': "12rem"}}
                        key={i}
                        onClick={() => routeRecipe(item)}
                    >
                      <VideoCard data={item}/>
                        {/* <MostPopularCard recipe={item} /> */}
                        
                    </div>
                    );
                }):<div className="d-flex justify-content-around scroll-snap-start w-100">No Most Popular Item</div> : <Loading width={100} height={100} />} 
                  {pageLoading && (
            <div className="d-flex justify-content-center align-items-center">
              <Loading />
            </div>
          )}
         </div>
        </section>
        </div>
  </section>);
};

export default MostPopularNew;
